import { render } from "./DataSelector.vue?vue&type=template&id=3e37e851&scoped=true"
import script from "./DataSelector.vue?vue&type=script&lang=js"
export * from "./DataSelector.vue?vue&type=script&lang=js"

import "./DataSelector.vue?vue&type=style&index=0&id=3e37e851&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e37e851"]])

export default __exports__